<template>
    <div class='button--load'>
        <div @click.prevent="!debouncedLoading && !loaded && $emit('submited')"
             :class="['submit-btn', {'round': debouncedLoading, 'loaded': loaded }]"
             ref='submit-btn'>
            <span v-show='!debouncedLoading && !loaded'>{{text}}</span>
            <span v-show='loaded'>
                <i class="checkmark"></i>
            </span>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Watch } from 'vue-property-decorator';

    @Component
    export default class LoadingButton extends Vue {
        name = 'loading-button';
        loaded = false;

        @Prop() loading;
        @Prop() text;

        debouncedLoading = false;

        @Watch('loading', { immediate: false })
        onLoadingChange (newVal, oldVal) {

            // Transition from false to true
            if (oldVal === false && newVal === true){
                this.debouncedLoading = true;
            }

            // Transition from true to false
            if (oldVal === true && newVal === false) {
                setTimeout(this.completeLoading, 2000);
            }
        }

        completeLoading() {
            this.debouncedLoading = false;
            this.loaded = true;
            setTimeout(this.restart, 1500);
        }

        restart() {
            this.$emit('complete');
            this.loaded = false;
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/general/LoadingButton.vue